import { render, staticRenderFns } from "./user-admin-edit.vue?vue&type=template&id=4a6fb64e&"
import script from "./user-admin-edit.vue?vue&type=script&lang=js&"
export * from "./user-admin-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports